/*
**	Two small utilities to display live YouTube Streams when
**  they occur.
**
** by Nate Beversluis, 2021
*/

function checkForLiveYouTube(currentTimer) {

	/*
	** Accesses a custom endpoint `/wp-json/custom/v2/youtube` that
	** provides information on the next upcoming LiveStream, then calls loadVideo()
	** if the livestream is less than 3 minutes in the future.
	*/

	fetch('/wp-json/custom/v2/youtube')
	.then( (result) => {			
        return result.json()})
    .then( (result) => { 		
        console.log(result);
        var videoInfo = JSON.parse(result);
        var startTime = new Date(videoInfo.start_time).getTime() / 1000;
        var now = Date.now() / 1000;	
        if (
            // event started in the past but less than two hours ago
             ( startTime - now < 0 && now - startTime < 7200  ) 
             
             ||
            // event starts in the future and will start within 3 minutes
            ( startTime > now  && ( (startTime - now) < 180 ) )
        ) {
            clearTimeout(currentTimer);
            loadVideo(videoInfo.info.items[0]);

        } else {
            currentTimer = setTimeout( checkForLiveYouTube, 10000);
        }
		return currentTimer
    });
}


function loadVideo(videoItem) {

	/*
	** Adapted from https://developers.google.com/youtube/iframe_api_reference
	**
	** Dynamically load a youTube video into the Highlights A slot, saving
	** the original HTML to replace it when the video ends.
	*/

	var title = videoItem.snippet.title;
	var description = videoItem.snippet.description;
	var originalHTML = jQuery('.query-highlights-2020-wrapper').html();
	var r = jQuery('.query-highlights-2020-wrapper').html(`
		<div id="player"></div>
		<div class="query-field query-field-post_title query-highlights overwritten">
			<h2>${title}</h2>
		</div>
		<div>
			<p class="video-stream-description">${description}</p>
		</div>`);	
		
	var player = new YT.Player('player', {
	  videoId: videoItem.id.videoId,
	  width: '100%',
	  listType: 'playlist',
	  events: {
		'onReady' : function() { 
			//console.log(player.getPlayerState()); 
			if (player.getPlayerState() == 0) {
				player.destroy();
				jQuery('.query-highlights-2020-wrapper').html(originalHTML);
				}
			},
		'onStateChange' : function(event) {
				//console.log(player.getPlayerState()); 
				if (event.data == 0) {
					player.destroy();
					jQuery('.query-highlights-2020-wrapper').html(originalHTML);
				}
			}
		}
	});
	
}


export { checkForLiveYouTube, loadVideo };